
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ContainActivityBtn, CourseItem } from '@xt/client/utils/activities/types'
import AUtils, { formatEndTimeCountdown } from '@xt/client/utils/activities'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Mixins(MixinsHomeClick) {
  @Prop({ required: true }) data!: CourseItem

  timer: ReturnType<typeof setInterval> | null = null
  countDown: string = ''
  btnConfig: ContainActivityBtn | null = null

  get labelStyle() {
    const map = {
      grey: this.$images.activity_2026_calligraphy_level2.course_tip_bg_img_grey,
      orange: this.$images.activity_2026_calligraphy_level2.course_tip_bg_img
    }

    if (this.data.label?.style) {
      if (map[this.data.label.style]) {
        return {
          class: this.data.label.style,
          url: map[this.data.label.style]
        }
      }
    }

    return {
      class: 'orange',
      url: map.orange
    }
  }

  get timeShow() {
    if (this.data.label) {
      const { custom, display } = this.data.label

      if (typeof display === 'boolean' && !display) return ''

      if (custom) return custom
    }

    if (!this.btnConfig) return ''

    return this.countDown ? this.countDown : this.btnConfig.label ? this.btnConfig.label : ''
  }

  clearTick() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  pad(n: number) {
    return String(n).padStart(2, '0')
  }

  getCountDownText(endTime: number) {
    const res = formatEndTimeCountdown(endTime)

    if (res.isEnd) return ''

    if (res.days > 0) {
      return `报名剩余${res.days}天`
    }

    return `报名剩余${this.pad(res.hours)}:${this.pad(res.minutes)}:${this.pad(res.seconds)}`
  }

  startTick() {
    const countdown = this.btnConfig?.countdown

    if (!countdown) return

    const downText = this.getCountDownText(countdown.endTime)

    if (!downText) return

    this.countDown = downText

    this.timer = setInterval(() => {
      this.countDown = this.getCountDownText(countdown.endTime)

      if (!this.countDown) {
        this.btnConfig = AUtils.mapContainCourseBtn(this.data)
        this.clearTick()
        return
      }
    }, 1000)
  }

  handleClick() {
    if (this.data.event) {
      this.onClickEvent(this.data.event)
      return
    }
  }

  created(): void {
    this.btnConfig = AUtils.mapContainCourseBtn(this.data)
    this.startTick()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.clearTick()
  }
}
